import { forwardRef } from 'react'

import { Visibility } from 'globalTypes'

import { Dialog } from '@headlessui/react'
import { Trans } from '@lingui/macro'
import BuyToSharePro from 'Root/App/Item/BuyToSharePro'
import ShareMine from 'Root/App/Item/ShareMine'

import PanelLayout from '../../PanelLayout'
import styles from './index.module.css'

interface Props {
  onClose: () => void
  onSave?: (visibility: Visibility) => void
}

export type Ref = HTMLDivElement

const Options = ({ onClose }: Props) => {
  return (
    <PanelLayout title={<Trans>Condividi</Trans>} onClose={onClose}>
      <span className={styles.optionsWrapper}>
        <ShareMine gratis active />
        <BuyToSharePro
          title={<Trans>Condividi privatamente</Trans>}
          description={
            <Trans>
              Condividi solo con chi vuoi tu e assegna permessi in sola lettura
              o di modifica. Genera link con token per condividere con
              semplicità e sicurezza.
            </Trans>
          }
          iconType="users"
        />
        <BuyToSharePro
          title={<Trans>Condividi con il mondo</Trans>}
          description={
            <Trans>
              Metti in mostra o monetizza i tuoi contenuti. Ottieni un link
              pubblico per promuoverlo dove vuoi tu.
            </Trans>
          }
          iconType="globe"
        />
      </span>
    </PanelLayout>
  )
}

const BuyToShareOptions = forwardRef<Ref, Props>(function BuyToShareOptions(
  { onClose, onSave },
  ref
) {
  return (
    <>
      <Dialog.Panel className={styles.dialogPanel} ref={ref}>
        <Options onClose={onClose} onSave={onSave} />
      </Dialog.Panel>
    </>
  )
})

export default BuyToShareOptions
